import CATEGORIAS from '../../../graphql/revista/queries/Categorias.gql';
import CATEGORIAS_BUSCA_AVANCADA from '../../../graphql/revista/queries/CategoriasBuscaAvancada.gql';
import CATEGORIA_SLUG from '../../../graphql/revista/queries/CategoriaFindSlug.gql';
import env from '../../../config/env';
import { errorGQLHandler } from '../../../helpers/helpers';
import * as types from '../../types/categoria.types';

const SET_CANAL = 'SET_CANAL';

export default {
  namespaced: true,
  state: {
    categorias: [],
    categoria: {},
    canal: null
  },
  getters: {
    getCategorias: state => state.categorias,
    canal: state => state.canal
  },
  mutations: {
    [types.CATEGORIAS](state, payload) {
      state.categorias = payload;
    },
    [SET_CANAL](state, payload) {
      state.canal = payload;
    },
  },
  actions: {
    createCategorias({ commit, state, dispatch }) {
      if (state.categorias.length <= 0) {
        env.apolloRevista
          .query({
            query: CATEGORIAS,
            variables: {
              modulo: env.revista.modulo,
              link_externo: "1",
              canal: state.canal,
              categoriaId: 0,
            },
          })
          .then(
            ({ data: { categorias } }) => {
              commit(types.CATEGORIAS, categorias.data);
              setTimeout(() => {
                dispatch('menu/menuHeader', categorias.data, { root: true });
              }, 300);
            },
            e => errorGQLHandler(e),
          );
      }
    },
    findCategoria(ctx, slug) {
      return new Promise(resolve => {
        env.apolloRevista
          .query({
            query: CATEGORIA_SLUG,
            variables: {
              modulo: env.revista.modulo,
              slug,
            },
          })
          .then(({ data: { categoria: { data } } }) => {
            resolve(data[0]);
          });
      });
    },
    async fetchAll() {
      return await env.apolloRevista.query({
        query: CATEGORIAS_BUSCA_AVANCADA,
        variables: {
          modulo: env.revista.modulo,
        },
      });
    },
    setCanal({ commit, dispatch }, canal) {
      commit(SET_CANAL, canal);
      commit(types.CATEGORIAS, []);   
      dispatch('createCategorias');
    },
  },
};
